import axios from "axios";
import { getAuthHeaders } from "../auth/util";
import { UserCurrency } from "./types";

export async function getUserWallet(userId: string) {
  var wallet = (
    await axios.get<UserCurrency[]>(
      `${process.env.REACT_APP_WANNABET_API}/wallets/${userId}`,
      {
        headers: getAuthHeaders(),
      }
    )
  ).data;

  return wallet;
}

export async function createUserWallet() {
  var wallet = (
    await axios.post<UserCurrency>(
      `${process.env.REACT_APP_WANNABET_API}/wallets`,
      {
        currencyId: 1,
      },
      {
        headers: getAuthHeaders(),
      }
    )
  ).data;

  return wallet;
}
